// Generated code, do not edit manually. Run the following command to regenerate it:
// > nx generate-icons packages/shared/render

import {SVGProps, ReactElement, createElement} from 'react';
import type {IconProps} from '@packages/utilities/icon-support';
export default /*#__PURE__#*/ function LabIconPreset(
  props: IconProps
): ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale =
    typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement(
    'svg',
    {
      'data-icon': 'LabIconPreset',
      'aria-hidden': true,
      focusable: false,
      width: 32 * scale,
      height: 32 * scale,
      viewBox: '0 0 32 32',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {
        ...{
          display: 'block',
        },
        ...props.style,
      },
    },
    createElement('path', {
      d: 'M27.333 25.793l-5.816-9.844a1.333 1.333 0 01-.184-.678V3.333A.667.667 0 0122 2.667h2A1.333 1.333 0 0024 0H8a1.333 1.333 0 000 2.667h2a.667.667 0 01.667.666v11.939a1.333 1.333 0 01-.186.677l-5.764 9.759A4 4 0 007.987 32h16.021a4 4 0 003.325-6.207zm-15.769-4.46a.667.667 0 01-.573-1.005l2.156-3.65a1.35 1.35 0 00.186-.678V3.333A.667.667 0 0114 2.667h4a.667.667 0 01.667.666V7a.667.667 0 01-.667.667h-1.76a1 1 0 000 2H18a.667.667 0 01.667.666v1.334a.667.667 0 01-.667.666h-1.76a1 1 0 000 2H18a.667.667 0 01.667.667v1a1.333 1.333 0 00.185.679l2.157 3.649a.667.667 0 01-.573 1.005zm1.084 7.763a2 2 0 112-2 2 2 0 01-2 2zm5.625-4.023a1.333 1.333 0 111.334-1.333 1.333 1.333 0 01-1.334 1.333zm3.334 4.11a1.333 1.333 0 111.333-1.334 1.333 1.333 0 01-1.34 1.334z',
      fill: 'currentColor',
    })
  );
}
